//import './styles/App.css';
import Header from './components/header';
import Intro from './components/intro';
import Projects from './components/projects';
import Certifications from './components/certifications';
import Skils from './components/skils';
import Footer from './components/footer';
function App() {
  return (
    <div >
      <Header/>
      <Intro/>
      <Projects/>
      <Certifications/>      
      <Skils/>
      <Footer/>

    </div>
    
  );
}

export default App;
